import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

export const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      github: file(relativePath: { eq: "github.svg" }) {
        publicURL
      }
      twitter: file(relativePath: { eq: "twitter.svg" }) {
        publicURL
      }
      linkedin: file(relativePath: { eq: "linkedin.svg" }) {
        publicURL
      }
      stackoverflow: file(relativePath: { eq: "stackoverflow.svg" }) {
        publicURL
      }
      kofi: file(relativePath: { eq: "kofi.svg" }) {
        publicURL
      }
      patreon: file(relativePath: { eq: "patreon.svg" }) {
        publicURL
      }
    }
  `)

  return (
    <FooterWrapper>
      <Inner>
        <Copy>© {new Date().getFullYear()} Khaled El Hamzi</Copy>
        <Icons>
          <a href="https://github.com/itsyst" target="_blank" rel="noopener noreferrer">
            <img src={data.github.publicURL} alt="GitHub" />
          </a>
          <a href="https://twitter.com/khaledelhamzi" target="_blank" rel="noopener noreferrer">
            <img src={data.twitter.publicURL} alt="X / Twitter" />
          </a>
          <a href="https://www.linkedin.com/in/khaledelhamzi/" target="_blank" rel="noopener noreferrer">
            <img src={data.linkedin.publicURL} alt="LinkedIn" />
          </a>
          <a
            href="https://stackoverflow.com/users/14376424/khaled-el-hamzi?tab=profile"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.stackoverflow.publicURL} alt="Stack Overflow" />
          </a>
          <a href="https://ko-fi.com/itsyst" target="_blank" rel="noopener noreferrer">
            <img src={data.kofi.publicURL} alt="Ko-fi" />
          </a>
          <a href="https://www.patreon.com/c/itsyst" target="_blank" rel="noopener noreferrer">
            <img src={data.patreon.publicURL} alt="Patreon" />
          </a>
        </Icons>
      </Inner>
    </FooterWrapper>
  )
}

const FooterWrapper = styled.footer`
  grid-column: 1 / -1;
  border-top: 1px solid var(--border);
  color: var(--muted);
`

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
  justify-content: space-between;
  width: min(80rem, 100%);
  margin: 0 auto;
  padding: 2rem 1.5rem;

  @media ${props => props.theme.breakpoints.tablet} {
    flex-direction: row;
    align-items: center;
  }
`

const Copy = styled.p`
  font-size: 0.875rem;
`

const Icons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    border-radius: var(--radius-md);
  }

  img {
    height: 1rem;
    width: 1rem;
  }

  a:hover img {
    filter: brightness(0.7);
  }
`
